import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircleIcon } from 'lucide-react';
export function Failures() {
  const failures = ['Tus oraciones se centran en el problema ("no tengo") en lugar de en la promesa, lo cual solo atrae más de lo mismo.', 'Tu visión es borrosa y ambigua; el cielo no puede financiar algo que tú mismo no has definido.', 'Confundes la humildad con la pobreza, ignorando que eres heredero del Dueño del oro y la plata.', 'Hablas de tus deudas con más fe de la que hablas de tu provisión.'];
  return <section className="py-20 bg-parchment-dark/50 relative overflow-hidden" data-id="element-20">
      <div className="container mx-auto px-4 relative z-10" data-id="element-21">
        <div className="max-w-4xl mx-auto" data-id="element-22">
          <FadeIn data-id="element-23">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-ink" data-id="element-24">
              Por qué lo que has intentado{' '}
              <span className="text-navy italic" data-id="element-25">no ha funcionado</span>
            </h2>
          </FadeIn>

          <div className="grid gap-6 md:grid-cols-2" data-id="element-26">
            {failures.map((failure, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-27">
                <div className="bg-white border border-parchment-dark p-6 rounded-xl h-full flex items-start gap-4 shadow-sm hover:shadow-md hover:border-gold/40 transition-all" data-id="element-28">
                  <XCircleIcon className="w-6 h-6 text-red-400 shrink-0 mt-1" data-id="element-29" />
                  <p className="text-charcoal leading-relaxed" data-id="element-30">{failure}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}